import React, {useContext, useEffect, useState} from 'react';
import { FaAngleUp, FaAngleDown, FaAngleDoubleUp, FaAngleDoubleDown ,FaWindowClose, FaPlus  } from "react-icons/fa";
import {
    addCategorie,
    addDocument,
    deleteCategorie,
    deleteDocument,
    getCategoriesWithDocumentsWithIdf,
    updateCategoriesWithDocuments
} from "../../api/mnhPratiqueService";
import {useLocation} from "react-router-dom";
import {decode} from "html-entities";
import { useDispatch, useSelector } from "react-redux";
import { isAdminKc, isRenderedAsAdmin } from "../../utils/keycloakUtils";
import { updateKeycloak } from "../../Redux/keycloak/keycloakReducer";
import { renderError } from "../../utils/formUtils";
import LoadingOverlay from "../../Components/LoadingOverlay/LoadingOverlay";
import TooltipDiv from "../../Components/Formulaire/TooltipDiv/TooltipDiv";


// TODO passer en reducer
export default function MnhPratique() {

    const {
        keycloakReduce,
        mnhPratique,
    } = useSelector(state => ({
        ...state.keycloakReducer,
        ...state.resourcesReducer,
    }))

    const dispatch = useDispatch()
    const location = useLocation()
    const pathname = location?.pathname

    const [mnhPratiquePageRef, setMnhPratiquePageRef] = useState()
    const [pageIdf, setPageIdf] = useState()
    const [submittedCategorie, setSubmittedCategorie] = useState(false)
    const [submittedDocument, setSubmittedDocument] = useState(false)
    const [isLoading, setIsLoading] = useState(true)

    const initCategorie = {
        value: "",
        invalid: "Nom de catégorie obligatoire",
    }

    const [categorieLibelle, setCategorieLibelle] = useState(initCategorie)

    const initDocument = {
        ordre: "",
        libelleDocument: {
            value: "",
            invalid: "Nom du document obligatoire",
        },
        linkDocument: {
            value: "",
            invalid: "Liens vers le document obligatoire",
        },
        idCategorie: null
    }

    const [newDocument, setNewDocument] = useState(initDocument)

    const [categoriesList, setCategoriesList] = useState([])

    useEffect(() => {

        const mnhPratiquePageRefIn = (mnhPratique?.find(({pageUrl}) => pathname.includes(pageUrl)))
        setPageIdf(mnhPratiquePageRefIn?.pageIdf)

        setMnhPratiquePageRef(mnhPratiquePageRefIn)

        const fetchBaseDocumentaire = async () => {

            const baseDocumentaireFromServer = await getCategoriesWithDocumentsWithIdf(mnhPratiquePageRefIn?.pageIdf)

            setCategoriesList(baseDocumentaireFromServer)

            setIsLoading(false)
        }

        fetchBaseDocumentaire()

    }, [pathname])

    const deplacerCategorie = (index, direction) => {
        const newBaseDocumentaire = [...categoriesList];
        const newIndex = direction === 'haut' ? index - 1 : index + 1;

        if (newIndex >= 0 && newIndex < newBaseDocumentaire.length) {
            const temp = newBaseDocumentaire[index];
            newBaseDocumentaire[index] = newBaseDocumentaire[newIndex];
            newBaseDocumentaire[newIndex] = temp;

            newBaseDocumentaire[index].ordre = index + 1;
            newBaseDocumentaire[newIndex].ordre = newIndex + 1;

            newBaseDocumentaire.sort((a, b) => a.ordre - b.ordre);

            majBaseDocumentaire(newBaseDocumentaire);
        }
    };

    const deplacerDocument = (catIndex, docIndex, direction) => {
        const newBaseDocumentaire = [...categoriesList];
        const categorie = newBaseDocumentaire[catIndex];
        const newDocIndex = direction === 'haut' ? docIndex - 1 : docIndex + 1;

        if (newDocIndex >= 0 && newDocIndex < categorie.documents.length) {
            const temp = categorie.documents[docIndex];
            categorie.documents[docIndex] = categorie.documents[newDocIndex];
            categorie.documents[newDocIndex] = temp;

            categorie.documents[docIndex].ordre = docIndex + 1;
            categorie.documents[newDocIndex].ordre = newDocIndex + 1;

            categorie.documents.sort((a, b) => a.ordre - b.ordre);

            newBaseDocumentaire[catIndex] = categorie;

            console.log("newBaseDocumentaire")
            console.log(newBaseDocumentaire)

            majBaseDocumentaire(newBaseDocumentaire);
        }
    };

    const handleInput = (e) => {

        const { name, value } = e?.target

        switch (name) {
            case 'categorieLibelle':

                if (value) {
                    setCategorieLibelle({
                        ...categorieLibelle,
                        value: value,
                        invalid: false,
                    })
                } else {
                    setCategorieLibelle({
                        ...categorieLibelle,
                        value: value,
                        invalid: "Catégorie obligatoire",
                    })
                }
                break;

            case 'linkDocument':
            case 'libelleDocument':
                if (value) {
                    setNewDocument({
                        ...newDocument,
                        [name]: {
                            ...newDocument?.[name],
                            value: value,
                            invalid: false,
                        }
                    })
                } else {
                    setNewDocument({
                        ...newDocument,
                        [name]: {
                            ...newDocument?.[name],
                            value: value,
                            invalid: "Obligatoire",
                        }
                    })
                }
                break;
        }
    }

    // TODO voir si il faut une confirmation de la sauvegarde
    const majBaseDocumentaire = async (newBaseDocumentaire) => {

        setIsLoading(true)

        try {
            const retour = await updateCategoriesWithDocuments(newBaseDocumentaire, pageIdf)

            console.log("retour", retour)

            const baseDocumentaireUpdated = retour?.rows

            if (baseDocumentaireUpdated) {
                setCategoriesList(baseDocumentaireUpdated)
            }

        } catch (err) {

            console.log("err", err)
        } finally {
            setIsLoading(false)
        }
    }

    const ajouterCategorie = async (e) => {

        e.preventDefault()
        setSubmittedCategorie(true)
        setIsLoading(true)

        if (categorieLibelle?.value) {

            const newCategorie = {
                libelle: categorieLibelle?.value,
                ordre: categoriesList?.length + 1,
                pageIdf: pageIdf,
            }

            try {

                const retour = await addCategorie(newCategorie, pageIdf)

                console.log("retour", retour)

                const baseDocumentaireUpdated = retour?.rows

                if (baseDocumentaireUpdated) {
                    setCategoriesList(baseDocumentaireUpdated)
                    // TODO dispatch
                    setSubmittedDocument(false)
                    setCategorieLibelle(initCategorie)
                }

            } catch (err) {

                console.log("err", err)
            } finally {
                setIsLoading(false)
            }
        } else {
            setIsLoading(false)
        }
    }

    // TODO mettre des contrôles
    const ajouterDocument = async (e, idCategorie) => {

        e.preventDefault()
        setSubmittedDocument(true)
        setIsLoading(true)

        const categorieToAdd = categoriesList?.find(categorie => categorie?.idCategorie === idCategorie)

        const libelleDocument = newDocument?.libelleDocument?.value
        const linkDocument = newDocument?.linkDocument?.value

        const documentToAdd = {
            libelle: libelleDocument,
            link: linkDocument,
            idCategorie: idCategorie,
            ordre: categorieToAdd?.documents?.length + 1,
        }

        if (libelleDocument && linkDocument) {
            try {

                const retour = await addDocument(documentToAdd, pageIdf)

                console.log("retour", retour)

                const baseDocumentaireUpdated = retour?.rows

                if (baseDocumentaireUpdated) {
                    setCategoriesList(baseDocumentaireUpdated)
                    setSubmittedDocument(false)
                    setNewDocument(initDocument)
                }

            } catch (err) {

                console.log("err", err)
            } finally {
                setIsLoading(false)
            }
        } else {
            setIsLoading(false)
        }
    }

    const supprimerCategorie = async (idCategorie) => {
        try {

            const retour = await deleteCategorie(idCategorie, pageIdf)

            console.log("retour", retour)

            const baseDocumentaireUpdated = retour?.rows

            if (baseDocumentaireUpdated) {
                setCategoriesList(baseDocumentaireUpdated)
            }

        } catch (err) {

            console.log("err", err)
        }
    }

    const supprimerDocument = async (idDoc, idCategorie) => {

        try {

            const retour = await deleteDocument(idDoc, idCategorie, pageIdf)
            console.log("retour", retour)

            const baseDocumentaireUpdated = retour?.rows

            if (baseDocumentaireUpdated) {
                setCategoriesList(baseDocumentaireUpdated)
            }

        } catch (err) {

            console.log("err", err)
        }
    }

    const isOnTop = (index) => {

        return index === 0
    }

    const isOnBottom = (index, listSize) => {

        return index === listSize - 1
    }

    const openDocumentForm = (idCategorie) => {

        if (idCategorie !== newDocument?.idCategorie) {

            setNewDocument({
                ...newDocument,
                idCategorie: idCategorie,
            })
        } else {
            setNewDocument({
                ...newDocument,
                idCategorie: null,
            })
        }
    }

    return (
        <div className="container-lg">

            <main id='content' className='overlay-container'>

                { isLoading && <LoadingOverlay classes="upload-overlay"/> }

                <h1 className="my-3">{ decode(mnhPratiquePageRef?.pageLibelle) }</h1>

                { isAdminKc(keycloakReduce?.decodedToken) ? (
                    <div className="float-end">
                        <TooltipDiv
                            Div={ <button className="btn btn-primary" type='button' onClick={ () => {
                                dispatch(updateKeycloak({ isRenderedAsAdmin: !keycloakReduce?.isRenderedAsAdmin }))
                            } }>
                                { isRenderedAsAdmin(keycloakReduce) ? "Mode utilisateur" : "Mode admin" }
                            </button> }
                            info={ 'Permet basculer entre le rendu administrateur et utilisateur' }
                        />

                    </div>
                ) : '' }

                <ul className="p-0">
                    { categoriesList?.length > 0 && categoriesList?.map((categorie, catIndex) => {

                        return (
                            <li key={ `categorie-${ categorie?.ordre }` } className='list-unstyled mt-3'>
                                <div>
                                    { (categoriesList.length > 1
                                        || isRenderedAsAdmin(keycloakReduce)) ? (<>
                                        <h2>{ decode(categorie?.libelle) }
                                            { isRenderedAsAdmin(keycloakReduce) ? (<>
                                                <TooltipDiv
                                                    Div={ <button
                                                        type="button"
                                                        onClick={ () => deplacerCategorie(catIndex, 'haut') }
                                                        className={ `icon-default ${ isOnTop(catIndex)
                                                            ? 'icon-disabled' : 'icon-blue' }` }
                                                        disabled={ isOnTop(catIndex) }
                                                    >
                                                        <FaAngleDoubleUp/>
                                                    </button> }
                                                    info={ 'Permet de remonter la catégorie au sein de la page' }
                                                />

                                                <TooltipDiv
                                                    Div={ <button
                                                        type="button"
                                                        onClick={ () => deplacerCategorie(catIndex, 'bas') }
                                                        className={ `icon-default ${ isOnBottom(catIndex, categoriesList?.length)
                                                            ? 'icon-disabled' : 'icon-blue' }` }
                                                    >
                                                        <FaAngleDoubleDown/>
                                                    </button>  }
                                                    info={ 'Permet de descendre la catégorie au sein de la page' }
                                                />

                                                <TooltipDiv
                                                    Div={ <button
                                                        type='button'
                                                        onClick={ () => supprimerCategorie(categorie?.idCategorie) }
                                                        className="icon-default icon-pink"
                                                    >
                                                        <FaWindowClose/>
                                                    </button> }
                                                    info={ 'Permet de supprimer la catégorie au sein de la page' }
                                                />

                                                <TooltipDiv
                                                    Div={ <button
                                                        type='button'
                                                        onClick={ () => openDocumentForm(categorie?.idCategorie) }
                                                        className="icon-default icon-blue"
                                                    >
                                                        <FaPlus/>
                                                    </button> }
                                                    info={ "Permet d'afficher le formulaire d'ajout de lien de document" }
                                                />
                                            </>) : '' }
                                        </h2>
                                    </>) : ''
                                    }
                                </div>

                                <div className="row">
                                    <div className='col-lg-6'>
                                        <ul>
                                            { categorie?.documents?.length > 0 && categorie?.documents?.map((document, docIndex) => {

                                                const { ordre, link, libelle } = document

                                                const isInsideApp = link.slice(0, 1) === '/'

                                                return (
                                                    <li key={ `categorie-${ categorie?.ordre }-${ document?.ordre }` }
                                                        className="list-unstyled">

                                                        <a href={ document?.link }
                                                           target={ isInsideApp ? '' : '_blank' }>{ decode(document?.libelle) }</a>

                                                        { isRenderedAsAdmin(keycloakReduce) ? (<>
                                                            <TooltipDiv
                                                                Div={ <button
                                                                    type="button"
                                                                    onClick={ () => deplacerDocument(catIndex, docIndex, 'haut') }
                                                                    className={ `icon-default ${ isOnTop(docIndex)
                                                                        ? 'icon-disabled' : 'icon-blue' }` }
                                                                >
                                                                    <FaAngleUp/>
                                                                </button> }
                                                                info={ 'Permet de remonter la position du lien au sein de la catégorie' }
                                                            />

                                                            <TooltipDiv
                                                                Div={ <button
                                                                    type="button"
                                                                    onClick={ () => deplacerDocument(catIndex, docIndex, 'bas') }
                                                                    className={ `icon-default ${ isOnBottom(docIndex, categorie?.documents?.length)
                                                                        ? 'icon-disabled' : 'icon-blue' }` }
                                                                >
                                                                    <FaAngleDown/>
                                                                </button> }
                                                                info={ 'Permet de descendre la position du lien au sein de la catégorie' }
                                                            />

                                                            <TooltipDiv
                                                                Div={ <button
                                                                    type='button'
                                                                    onClick={ () => supprimerDocument(document?.idDoc, categorie?.idCategorie) }
                                                                    className="icon-default icon-pink"
                                                                >
                                                                    <FaWindowClose/>
                                                                </button> }
                                                                info={ 'Permet de supprimer le lien de la catégorie' }
                                                            />
                                                        </>) : '' }
                                                    </li>
                                                )
                                            }) }
                                        </ul>
                                    </div>

                                    { isRenderedAsAdmin(keycloakReduce) ? (<>
                                        <div className="col-lg-6">

                                            { newDocument?.idCategorie === categorie?.idCategorie && (
                                                <form onSubmit={ (e) => ajouterDocument(e, categorie?.idCategorie) }>

                                                    <div className="mb-3 col-lg-6">
                                                        <label
                                                            htmlFor="libelleDocument"
                                                            className="form-label">
                                                            Nom du document à ajouter :
                                                        </label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            id="libelleDocument"
                                                            name="libelleDocument"
                                                            onChange={ handleInput }
                                                            value={ newDocument?.libelleDocument?.value }
                                                            placeholder="ex : Fiche métier"/>

                                                        { submittedDocument && newDocument?.libelleDocument?.invalid
                                                            && renderError(newDocument?.libelleDocument?.invalid) }
                                                    </div>

                                                    <div className="mb-3 col-lg-8">
                                                        <label
                                                            htmlFor="linkDocument"
                                                            className="form-label">
                                                            Lien vers le document :
                                                        </label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            id="linkDocument"
                                                            name="linkDocument"
                                                            onChange={ handleInput }
                                                            value={ newDocument?.linkDocument?.value }
                                                            placeholder="htpps://mon-lien"/>

                                                        { submittedDocument && newDocument?.linkDocument?.invalid
                                                            && renderError(newDocument?.linkDocument?.invalid) }
                                                    </div>

                                                    <div>
                                                        <button
                                                            className='btn btn-primary'
                                                            type='submit'
                                                        >
                                                            Ajouter
                                                        </button>
                                                        <button
                                                            className='btn btn-secondary ms-2'
                                                            type='button'
                                                            onClick={ () => openDocumentForm(categorie?.idCategorie) }
                                                        >
                                                            Annuler
                                                        </button>
                                                    </div>

                                                </form>
                                            ) }
                                        </div>
                                    </>) : '' }
                                </div>
                            </li>
                        )
                    }) }
                </ul>

                { isRenderedAsAdmin(keycloakReduce) ? (<>
                    <form onSubmit={ ajouterCategorie } className='mt-5'>

                        <h1>Ajouter une catégorie</h1>

                        <div className="mb-3 col-lg-6">
                            <label
                                htmlFor="categorieLibelle"
                                className="form-label">
                                Nom de la catégorie à ajouter :
                            </label>
                            <input
                                type="text"
                                className="form-control"
                                id="categorieLibelle"
                                name="categorieLibelle"
                                onChange={ handleInput }
                                value={ categorieLibelle?.value }
                                placeholder="La nouvelle catégorie"/>
                            { submittedCategorie && categorieLibelle?.invalid
                                && renderError(categorieLibelle?.invalid) }
                        </div>

                        <div>
                            <button type='submit' className="btn btn-primary">
                                Ajouter catégorie
                            </button>
                        </div>
                    </form>
                </>) : '' }
            </main>
        </div>
    )
}